export const mapImageToCallOutBulletList = (imageBulletList) => {
  return imageBulletList.map((item) => ({
    iconBulletPointListHeading: item.imageIconBulletPointListHeading,
    iconBulletPointListTextMultiParagraphSection:
      item.imageIconBulletPointListTextMultiParagraphSection.map((p) => ({
        iconBulletPointListTextParagraph:
          p.imageIconBulletPointListTextParagraph,
      })),
    iconBulletPointListIcon: item.imageIconBulletPointListIcon,
  }));
};
